<div class="main-container">
  <div class="content-container">
    <div class="content-area main-content">
      <div class="clr-row main-row">
        <div class="clr-col-4 left-banner" style="background-image: url('assets/imgs/app-selection-landing.jpg');">
        </div>
        <div class="clr-col-8 ">
          <div class="clr-row right-header">
            <div class="clr-col-12">
              <img src="assets/logos/CorHealth-OH-Eng-Pos-RGB.png" class="logo" alt="Ontario Health - CorHealth Ontario"/>
            </div>
          </div>
          <div class="clr-row right-main">
            <div class="clr-col-12" >
              <div class="clr-row" role="alert" *ngIf="showSessionTimeoutAlert()">
                <div class="clr-col-8 clr-offset-2 alert alert-danger alert-items mb-3">
                    <div class="alert-item static">
                        <div class="alert-icon-wrapper">
                            <clr-icon class="alert-icon" shape="exclamation-circle"></clr-icon>
                        </div>
                        <span class="alert-text">
                          You have been logged out. Please ensure you are only accessing the DCIS through only one tab in one browser window. The DCIS is not intended to support multi-tab or window use.
                        </span>
                    </div>
                </div>
              </div>
              <div class="clr-row">
                <div class="clr-col-12 app-title" >
                  Data Collection & Information System
                </div>
              </div>
              <div class="clr-row apps">
                <div class="clr-error mb-4 clr-col-12" *ngIf="profileSelectionError && profileSelectionError.length > 0">
                  <span class="clr-subtext">
                    <clr-icon shape="error-standard"></clr-icon> {{profileSelectionError}}
                  </span>
                </div>
                <div class="clr-col-md-4 clr-col-12">
                  <a class="card clickable" (click)="login()">
                    <div class="card-block card-img">
                        <img src="assets/imgs/dcis-data-collection-app.png" alt="Cardiac Data Collection"/>
                    </div>
                    <div class='card-footer'>
                      Cardiac Data Collection
                    </div>
                  </a>
                </div>
                <div class="clr-col-md-4 clr-col-12">
                  <a class="card clickable" (click)="reportLogin()">
                    <div class="card-block card-img">
                        <img src="assets/imgs/dcis-report-app.png" alt="Reporting"/>
                    </div>
                    <div class='card-footer'>
                      Reporting
                    </div>
                  </a>
                </div>
                <div class="clr-col-md-4 clr-col-12">
                  <div class="card" style="margin-top: 0;" href="registration-app">
                    <div class="card-block card-img">
                        <img src="assets/imgs/dcis-registration-app.png" alt="Registration"/>
                    </div>
                    <div class='card-footer'>
                      Registration
                    </div>
                  </div>
                </div>                
              </div>
            </div>
          </div>
          <div class="clr-row right-footer">
            <div class="clr-col-12">
              <p class="contact-text">For assistance, contact the Ontario Health - CorHealth Ontario Service Desk - </p>
              <p class="contact-text">Monday to Friday, 8:30 am to 5:00 pm</p>
              <p class="contact-text"><a class="contact-text" href="mailto:OH-CORH_Service@ontariohealth.ca">OH-CORH_Service@ontariohealth.ca</a></p>
              <p class="contact-text">416-512-7472 ext. 1</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

